import script from "./MarkerCategoryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkerCategoryTable.vue?vue&type=script&setup=true&lang=js"

import "./MarkerCategoryTable.vue?vue&type=style&index=0&id=b065a420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b065a420"]])

export default __exports__